// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Addresses from 'Containers/Addresses/Addresses';
import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';

const StyledAddressesPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const AddressesPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let addressesPageClassName = bodyAttributes?.class || '';
  if (!addressesPageClassName.includes('AddressesPage')) {
    addressesPageClassName += 'AddressesPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <body className={ addressesPageClassName } />
        <title>{ t('common.pages.addresses') }</title>
      </Helmet>
      <StyledAddressesPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <Addresses />
      </StyledAddressesPage>
    </>
  );
});
AddressesPage.displayName = 'AddressesPage';

export default AddressesPage;
